export default __webpack_public_path__ + "static/media/img-0107-canada-full-face.28bd4bb6.png";